import moment from "moment"
import {Activity, StudentActivity} from "types/activity"

type ActivityWithLegacyId = Activity & {id?: number}

const getActivityId = (activity?: ActivityWithLegacyId) => activity?.activityId ?? activity?.id

/** Returns the default due-alert time shown and persisted by ActivityForm. */
export const getDefaultStudentDueTime = () => moment().startOf("day").hour(9).toISOString()

/** Builds the server-side filters used by ActivityForm's activity query. */
export const getActivityQueryFilter = (sourceDepartmentId?: number | null) => ({
    isActive: true,
    ...(sourceDepartmentId ? {departmentIds: [sourceDepartmentId]} : {})
})

/**
 * Mirrors ActivityForm's legacy status filter. A status-changing activity can be excluded when the form is reopened
 * because the student's current status no longer matches the activity's allowed source statuses.
 */
export const getStudentStatusActivityTypes = (activities: Activity[], studentStatusId?: number) =>
    activities.filter(
        (activity) =>
            !activity.studentStatuses?.length ||
            studentStatusId == null ||
            activity.studentStatuses.some((status) => status.statusId === studentStatusId)
    )

export const shouldConfirmStatusChange = (activity?: Activity, originalActivityId?: number) =>
    !!activity?.updateToStudentStatusId &&
    (originalActivityId == null || getActivityId(activity) !== originalActivityId)

export const getEditableStudentDue = (studentDue?: StudentActivity["studentDue"]) => {
    if (!studentDue) return studentDue

    return {
        ...studentDue,
        time: studentDue.time || getDefaultStudentDueTime(),
        notifyStaffRoleIds: studentDue.notifyStaffRoleIds || [],
        notifyStaffProfileIds: studentDue.notifyStaffProfileIds || [],
        notifyStaffProfiles: studentDue.notifyStaffProfiles || []
    }
}
